<script>
import {isEmpty, isNil} from "lodash";
import Spinner from "../../Spinner.vue";
import ActiveVehicle from "../ActiveVehicle.vue";
import AppointmentStore from "../../../mixins/appointment-store";

export default {
    name: "VehicleInfo",

    props: {
        uspsText: String,
        vehicleText: String,
    },

    mixins: [AppointmentStore],

    components: {
        ActiveVehicle,
        Spinner
    },

    data() {
        return {
            emptyOrError: false,
            loading: false,
        }
    },

    computed: {
        vehicleData() {
            return this.appointmentStore.vehicleData;
        }
    },

    methods: {
        handleFetchVehicleData() {
            this.loading = true;
            this.emptyOrError = false;

            axios.get('/api/rdw-client', {
                params: {
                    licensePlate: this.appointmentStore.licensePlate
                }
            })
                .then(response => {
                    if (isNil(response.data) || isEmpty(response.data)) {
                        this.appointmentStore.vehicleData = null;
                        this.emptyOrError = true;
                        return;
                    }

                    this.appointmentStore.vehicleData = response.data;
                })
                .catch(error => {
                    this.appointmentStore.vehicleData = null;
                    this.emptyOrError = true;
                })
                .finally(() => this.loading = false);
        },
    }
}
</script>

<template>
    <div class="vue-vehicle-info">
        <div class="container">
            <div class="row m-0 ">
                <div class="sidebar">
                    <div class="inner" v-html="uspsText"></div>
                </div>
                <div class="content">
                    <div v-html="vehicleText"></div>
                    <div>
                        <div class="button-wrapper">
                            <input v-model="appointmentStore.licensePlate" type="text" class="kentekenplaat">
                            <button class="btn-arrow" :disabled="loading || !appointmentStore.hasLicensePlate" @click="handleFetchVehicleData">
                                Check mijn kenteken

                                <Spinner v-if="loading"/>
                            </button>
                        </div>

                        <div v-if="emptyOrError">
                            <div class="alert alert-danger alert-dismissible mt-4" role="alert">
                                Er is iets fout gegaan of er is geen data voor dit kenteken gevonden, vul een correct
                                kenteken in, probeer het later opnieuw of ga door zonder kenteken.

                                <button type="button" @click.stop="emptyOrError = false" class="close"
                                        data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>

                        <div v-if="appointmentStore.hasVehicleData">
                            <hr>
                            <div class="active-vehicle-wrapper">
                                <ActiveVehicle :request-offer="requestOffer"/>
                            </div>

                            <button class="btn-arrow" @click="appointmentStore.goToStep(2)">
                                Stap 2 - Zoek een vestiging
                            </button>
                        </div>

                        <div v-if="!appointmentStore.hasVehicleData">
                            <hr>
                            <button class="btn-arrow-inverse" @click="appointmentStore.goToStep(2)">
                                Ga door zonder kenteken
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>